/** Linked picture layers of one product in one picture set: a pick on any frame sets them all. */
export function slotLinkGroupId(layoutId: string, fileSetId: string, product: number): string {
  return `${layoutId}-${fileSetId}-p${product}`;
}

/** A layer's shared value for one product. Every product gets its own, the template's
 *  included, so a text matched by name across formats never ties two products together. */
export function slotProductId(id: string, product: number): string {
  return `${slotProductBase(id)}-p${product}`;
}

/** The id behind a product's shared value, without the product. */
export function slotProductBase(id: string): string {
  return id.replace(/-p\d+$/, '');
}

export function slotTemplateSharedFieldId(layoutId: string, uuid: number): string {
  return `${layoutId}-t${uuid}`;
}
